(function () {
  document.documentElement.classList.add('ialt-js');

  function createFilmGrain() {
    if (document.querySelector('.ialt-grain-canvas')) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'ialt-grain-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d', { alpha: true });
    var w = 0;
    var h = 0;
    var last = 0;
    var interval = 58;
    var scratchTimer = 0;
    var scratches = [];

    function resize() {
      w = Math.max(360, Math.ceil(window.innerWidth / 2.4));
      h = Math.max(260, Math.ceil(window.innerHeight / 2.4));
      canvas.width = w;
      canvas.height = h;
      canvas.style.width = '100vw';
      canvas.style.height = '100vh';
      ctx.imageSmoothingEnabled = false;
    }

    function randomScratches(now) {
      if (now > scratchTimer) {
        scratchTimer = now + 420 + Math.random() * 900;
        scratches = [];
        var count = Math.random() > 0.55 ? 1 + Math.floor(Math.random() * 3) : 0;
        for (var i = 0; i < count; i++) {
          scratches.push({
            x: Math.random() * w,
            y: Math.random() * h,
            len: 40 + Math.random() * h * 0.7,
            a: 10 + Math.random() * 34,
            width: Math.random() > 0.8 ? 2 : 1
          });
        }
      }
    }

    function draw(now) {
      if (!last || now - last > interval) {
        last = now;
        var imageData = ctx.createImageData(w, h);
        var data = imageData.data;
        for (var i = 0; i < data.length; i += 4) {
          var r = Math.random();
          var shade = r > 0.5 ? 255 : 0;
          var alpha;
          if (r > 0.985) alpha = 95 + Math.random() * 95;
          else if (r < 0.015) alpha = 65 + Math.random() * 90;
          else alpha = Math.random() * 34;
          data[i] = shade;
          data[i + 1] = shade;
          data[i + 2] = shade;
          data[i + 3] = alpha;
        }
        ctx.putImageData(imageData, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        for (var b = 0; b < 18; b++) {
          var y = Math.floor(Math.random() * h);
          var bandH = 1 + Math.floor(Math.random() * 4);
          ctx.fillStyle = Math.random() > 0.5 ? 'rgba(255,255,255,' + (Math.random() * 0.08).toFixed(3) + ')' : 'rgba(0,0,0,' + (Math.random() * 0.10).toFixed(3) + ')';
          ctx.fillRect(0, y, w, bandH);
        }
        randomScratches(now);
        scratches.forEach(function (s) {
          ctx.fillStyle = 'rgba(255,255,255,' + (s.a / 255).toFixed(3) + ')';
          ctx.fillRect(Math.floor(s.x), Math.floor(s.y), s.width, s.len);
        });
      }
      requestAnimationFrame(draw);
    }

    resize();
    window.addEventListener('resize', resize, { passive: true });
    requestAnimationFrame(draw);
  }

  function initMobileFocus() {
    var media = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };
    var composition = document.querySelector('.ialt-home .ialt-composition');
    if (!composition) return;

    var products = Array.prototype.slice.call(composition.querySelectorAll('.ialt-floating-product'));
    if (!products.length) return;

    var ticking = false;

    function clearFocus() {
      composition.classList.remove('ialt-focus-ready', 'ialt-distance-focus');
      products.forEach(function (product) {
        product.classList.remove('is-active', 'is-inactive');
        product.style.removeProperty('opacity');
        product.style.removeProperty('filter');
        product.style.removeProperty('transform');
      });
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function updateFocus() {
      ticking = false;

      if (!media.matches) {
        clearFocus();
        return;
      }

      composition.classList.add('ialt-focus-ready', 'ialt-distance-focus');

      var focusY = window.innerHeight * 0.52;
      var fadeDistance = window.innerHeight * 0.46;
      var best = products[0];
      var bestScore = Infinity;

      products.forEach(function (product) {
        var rect = product.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var distance = Math.abs(center - focusY);
        var t = clamp(distance / fadeDistance, 0, 1);

        // Ease the falloff so it gradually slips out of focus instead of snapping.
        var eased = t * t * (3 - 2 * t);
        var opacity = 1 - eased * 0.86;
        var blur = eased * 13;
        var brightness = 1 - eased * 0.28;
        var saturation = 1 - eased * 0.20;
        var scale = 1 - eased * 0.055;

        product.style.setProperty('opacity', opacity.toFixed(3), 'important');
        product.style.setProperty('filter', 'blur(' + blur.toFixed(2) + 'px) saturate(' + saturation.toFixed(3) + ') brightness(' + brightness.toFixed(3) + ')', 'important');
        product.style.setProperty('transform', 'scale(' + scale.toFixed(3) + ')', 'important');

        if (distance < bestScore) {
          bestScore = distance;
          best = product;
        }
      });

      products.forEach(function (product) {
        var active = product === best;
        product.classList.toggle('is-active', active);
        product.classList.toggle('is-inactive', !active);
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateFocus);
    }

    composition.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.addEventListener('orientationchange', requestUpdate, { passive: true });
    if (media.addEventListener) media.addEventListener('change', requestUpdate);
    else if (media.addListener) media.addListener(requestUpdate);

    requestUpdate();
    setTimeout(requestUpdate, 120);
    setTimeout(requestUpdate, 500);
    setTimeout(requestUpdate, 1200);
  }

  function boot() {
    createFilmGrain();
    initMobileFocus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
